import * as Yup from 'yup';
import { getValidationRules } from '../../../../validation';
// @ts-ignore
import meta from '../../calculatorMetaData.json'

export const validation = Yup.object().shape({
  // @ts-ignore
  ...getValidationRules(meta)
});
